import { LIBRARY } from '@flobi/artwork-core/plugin-library';

/**
 * Starting points for "Add from code": the Flobi library itself.
 *
 * One copy of each add-on, in `@flobi/artwork-core/plugin-library`, where it is reviewed and
 * tested in the real sandbox. Starting from one of these makes a private add-on of your
 * own — the library row is untouched, and nobody else sees your changes.
 */
export const EXAMPLES: readonly { readonly name: string; readonly source: string }[] = LIBRARY.map((addon) => ({
  // Named from the slug so the list needs no sandbox to draw: the real name is whatever
  // the add-on declares, which is read when it is added.
  name: addon.slug.replace(/-/g, ' ').replace(/^./, (first) => first.toUpperCase()),
  source: addon.source,
}));
